import React from "react";

const STAGES = [
  {
    n: "1",
    title: "THE TAKEOVER BEGINS",
    copy: [
      "David Brent and his colleagues from Shanghai Investments UK arrive at your workplace to conduct due diligence.",
      "They introduce themselves, explain their acquisition philosophy (plus David’s personal philosophy on life) and begin getting to know the business and the people behind it.",
    ],
  },
  {
    n: "2",
    title: "THE SERIOUS BIT. MOSTLY.",
    copy: [
      "At the heart of the afternoon is a genuine training session.",
      "As standard, this focuses on storytelling: how to communicate ideas more effectively across branding, sales, strategy and everyday business life.",
      "But it doesn’t have to.",
      "You can choose a specific area of development that matters most to your organisation.",
      "We can bring in an expert in that field, or your own learning and development leader can deliver that part of the session (and David will be under strict instructions not to heckle them).",
    ],
  },
  {
    n: "3",
    title: "THE VERDICT",
    copy: [
      "At the end of the afternoon, Shanghai Investments reconvenes.",
      "David and his colleagues present their findings and reveal what they believe your business should do next.",
      "Some recommendations may even be useful.",
      "Others absolutely should not be implemented.",
    ],
  },
];

export const TakeoverStages = () => (
  <ol className="tk-stages" data-testid="tk-stages">
    {STAGES.map((s) => (
      <li key={s.n} className="tk-stage" data-testid={`tk-stage-${s.n}`}>
        <div className="tk-stage-marker" aria-hidden="true">
          <span className="tk-stage-num">{s.n}</span>
        </div>
        <div className="tk-stage-content">
          <h3 className="tk-stage-title">{s.title}</h3>
          <div className="tk-body">
            {s.copy.map((p) => <p key={p}>{p}</p>)}
          </div>
        </div>
      </li>
    ))}
  </ol>
);

const OUTCOMES = [
  ["Practical skills", "Tools and ideas they can actually use when they return to work."],
  ["Fresh insight", "A different perspective on the business, the team and the way they work together."],
  ["A shared story", "An experience people will still be talking about long after another conventional training session would have disappeared from memory."],
];

export const TakeoverOutcomes = () => (
  <ul className="tk-outcomes" data-testid="tk-outcomes">
    {OUTCOMES.map(([title, copy]) => (
      <li key={title} className="tk-outcome">
        <h3 className="tk-outcome-title">{title}</h3>
        <p className="tk-outcome-copy">{copy}</p>
      </li>
    ))}
  </ul>
);

const FOCUS = ["Storytelling", "Sales", "Leadership", "Communication", "Productivity", "Artificial Intelligence", "Or another area that matters to you"];

export const TakeoverFocusList = () => (
  <ul className="tk-focus" data-testid="tk-focus-list">
    {FOCUS.map((item, i) => (
      <li key={item} className={`tk-focus-item${i === FOCUS.length - 1 ? " tk-focus-item--open" : ""}`}>
        {item}
      </li>
    ))}
  </ul>
);
